import { IItemRights, IItemRightsCollection } from "../../../Global/Base/Rights/RightTypes";

/**
 * Mutable v tom, že do jednotlivých fieldů lze přiřadit (neměnná) hodnota.
 */
export class MutableItemRightsCollection implements IItemRightsCollection {
    public enabled: ReadonlyArray<IItemRights> | undefined = undefined;
    public postponedRequired: ReadonlyArray<IItemRights> | undefined = undefined;
    public recommended: ReadonlyArray<IItemRights> | undefined = undefined;
    public required: ReadonlyArray<IItemRights> | undefined = undefined;
    public visible: ReadonlyArray<IItemRights> | undefined = undefined;
    public closeForm: ReadonlyArray<IItemRights> | undefined = undefined;
    public validateIf: ReadonlyArray<IItemRights> | undefined = undefined;
    public confirmIf: ReadonlyArray<IItemRights> | undefined = undefined;
    public useDigitalSign: ReadonlyArray<IItemRights> | undefined = undefined;
    public useEncryption: ReadonlyArray<IItemRights> | undefined = undefined;
    public useDecryption: ReadonlyArray<IItemRights> | undefined = undefined;
    public openAsEnabled: ReadonlyArray<IItemRights> | undefined = undefined;

    public showIfDefault: boolean | undefined = undefined;
}
